/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockDepletedListResVo
 */
export interface AdminStockDepletedListResVo {
    /**
     * SKU主键ID
     * @type {number}
     * @memberof AdminStockDepletedListResVo
     */
    skuId?: number;
    /**
     * SKU编码
     * @type {string}
     * @memberof AdminStockDepletedListResVo
     */
    skuCode?: string;
    /**
     * SKU主图URL
     * @type {string}
     * @memberof AdminStockDepletedListResVo
     */
    imageUrl?: string;
    /**
     * 登录商品名称
     * @type {string}
     * @memberof AdminStockDepletedListResVo
     */
    productName?: string;
    /**
     * 会员ID
     * @type {number}
     * @memberof AdminStockDepletedListResVo
     */
    userId?: number;
    /**
     * 会员编号
     * @type {string}
     * @memberof AdminStockDepletedListResVo
     */
    userCode?: string;
    /**
     * 会员名
     * @type {string}
     * @memberof AdminStockDepletedListResVo
     */
    userName?: string;
    /**
     * 单价(¥)
     * @type {number}
     * @memberof AdminStockDepletedListResVo
     */
    unitPrice?: number;
    /**
     * 重量(kg)，多批次时取最新批次 goods
     * @type {number}
     * @memberof AdminStockDepletedListResVo
     */
    weightKg?: number;
    /**
     * 包装规格(cm)，格式：长x宽x高
     * @type {string}
     * @memberof AdminStockDepletedListResVo
     */
    packageSpecCm?: string;
    /**
     * 单个CBM
     * @type {number}
     * @memberof AdminStockDepletedListResVo
     */
    singleCbm?: number;
    /**
     * 可用库存数量（耗尽列表恒为0）
     * @type {number}
     * @memberof AdminStockDepletedListResVo
     */
    availableQty?: number;
    /**
     * 冻结数量
     * @type {number}
     * @memberof AdminStockDepletedListResVo
     */
    freezeQty?: number;
    /**
     * 库存总数量（可用+冻结）
     * @type {number}
     * @memberof AdminStockDepletedListResVo
     */
    totalQty?: number;
    /**
     * 库存状态码，见 StockSkuInventoryStatusEnum
     * @type {number}
     * @memberof AdminStockDepletedListResVo
     */
    inventoryStatus?: number;
    /**
     * 库存状态名称（国际化）
     * @type {string}
     * @memberof AdminStockDepletedListResVo
     */
    inventoryStatusLabel?: string;
    /**
     * 最后耗尽日期
     * @type {string}
     * @memberof AdminStockDepletedListResVo
     */
    lastDepletedDate?: string;
}

/**
 * Check if a given object implements the AdminStockDepletedListResVo interface.
 */
export function instanceOfAdminStockDepletedListResVo(value: object): value is AdminStockDepletedListResVo {
    return true;
}

export function AdminStockDepletedListResVoFromJSON(json: any): AdminStockDepletedListResVo {
    return AdminStockDepletedListResVoFromJSONTyped(json, false);
}

export function AdminStockDepletedListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockDepletedListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'productName': json['productName'] == null ? undefined : json['productName'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'weightKg': json['weightKg'] == null ? undefined : json['weightKg'],
        'packageSpecCm': json['packageSpecCm'] == null ? undefined : json['packageSpecCm'],
        'singleCbm': json['singleCbm'] == null ? undefined : json['singleCbm'],
        'availableQty': json['availableQty'] == null ? undefined : json['availableQty'],
        'freezeQty': json['freezeQty'] == null ? undefined : json['freezeQty'],
        'totalQty': json['totalQty'] == null ? undefined : json['totalQty'],
        'inventoryStatus': json['inventoryStatus'] == null ? undefined : json['inventoryStatus'],
        'inventoryStatusLabel': json['inventoryStatusLabel'] == null ? undefined : json['inventoryStatusLabel'],
        'lastDepletedDate': json['lastDepletedDate'] == null ? undefined : json['lastDepletedDate'],
    };
}

export function AdminStockDepletedListResVoToJSON(json: any): AdminStockDepletedListResVo {
    return AdminStockDepletedListResVoToJSONTyped(json, false);
}

export function AdminStockDepletedListResVoToJSONTyped(value?: AdminStockDepletedListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'imageUrl': value['imageUrl'],
        'productName': value['productName'],
        'userId': value['userId'],
        'userCode': value['userCode'],
        'userName': value['userName'],
        'unitPrice': value['unitPrice'],
        'weightKg': value['weightKg'],
        'packageSpecCm': value['packageSpecCm'],
        'singleCbm': value['singleCbm'],
        'availableQty': value['availableQty'],
        'freezeQty': value['freezeQty'],
        'totalQty': value['totalQty'],
        'inventoryStatus': value['inventoryStatus'],
        'inventoryStatusLabel': value['inventoryStatusLabel'],
        'lastDepletedDate': value['lastDepletedDate'],
    };
}

